"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OVERRIDES_KEY = exports.META_KEY = exports.CONFIGURATION_KEY = void 0;
exports.CONFIGURATION_KEY = 'eppo-configuration';
exports.META_KEY = 'eppo-configuration-meta';
exports.OVERRIDES_KEY = 'eppo-overrides';
//# sourceMappingURL=storage-key-constants.js.map